export class UtilityService {

	/**
	 * Suspends a Promise for the specified number of milliseconds
	 * @return Promise<T>
	  */
	public static asyncTimeout = <T>(asyncCall: Promise<T>, timeout: number = 700): Promise<T> => {

		const timeoutPromise = new Promise((res) => {
			setTimeout(() => {
				res();
			}, timeout);
		});

		return Promise.all([asyncCall, timeoutPromise]).then(values => values[0]);
	}

	public static extractReduceQuotedStrings = (string: string): { quotedValues: string[], remainingString: string } => {

		let strictKeywordsMatch: RegExpMatchArray | null = [];
		const strictKeywords: string[] = [];
		const strictSearchRegex = /\"[^\"]*\"/ig;

		strictKeywordsMatch = string.match(strictSearchRegex);
		if (strictKeywordsMatch !== null) {

			strictKeywords.push(...strictKeywordsMatch.map((keywords) => keywords.replace(/\"/g, "")));
			strictKeywordsMatch.forEach((match) => {
				string = string!.replace(match, "");
			});
		}

		return {
			quotedValues: strictKeywords,
			remainingString: string
		};
	}

	public static getCurrentDate = (): string => {
		const date = new Date();
		const year = date.getFullYear();

		let month = (1 + date.getMonth()).toString();
		month = month.length > 1 ? month : "0" + month;

		let day = date.getDate().toString();
		day = day.length > 1 ? day : "0" + day;

		return `${month}/${day}/${year} - ${date.getHours() % 12}:${date.getMinutes()} ${date.getHours() > 11 ? "pm" : "am"}`;
	}
}
